/**
 * Mixin for @ mention hover popover behavior in markdown content.
 * Requires the component to define getMentionPopoverContainer() returning the DOM element
 * that contains .mention elements. Optionally define mentionPopoverDisabled (computed) to
 * disable the popover (e.g. when isInline).
 */
export default {
    data () {
        return {
            showMentionPopover: false,
            mentionData: {
                type: '',
                id: '',
                text: '',
            },
            popoverTimeout: null,
            popoverReferenceElement: null,
        };
    },
    mounted () {
        this.$nextTick(() => {
            const container = this.getMentionPopoverContainer?.();
            if (container) {
                container.addEventListener('mouseover', this._mentionPopoverOnMouseEnter);
                container.addEventListener('mouseout', this._mentionPopoverOnMouseLeave);
            }
        });
    },
    beforeUnmount () {
        const container = this.getMentionPopoverContainer?.();
        if (container) {
            container.removeEventListener('mouseover', this._mentionPopoverOnMouseEnter);
            container.removeEventListener('mouseout', this._mentionPopoverOnMouseLeave);
        }
        this._mentionPopoverCleanup();
    },
    methods: {
        getMentionPopoverContainer () {
            // Component must override to return the markdown container element (e.g. this.$refs.content)
            return null;
        },
        _mentionPopoverOnMouseEnter (event) {
            if (this.mentionPopoverDisabled) {
                return;
            }
            const target = event.target.closest('.mention');
            if (target) {
                if (this.popoverTimeout) {
                    clearTimeout(this.popoverTimeout);
                }

                const dataType = target.getAttribute('data-type');
                const dataId = target.getAttribute('data-id');

                if (!dataType || !dataId) return;

                this.mentionData = {
                    type: dataType || '',
                    id: dataId || '',
                    text: target.textContent || '',
                };
                this.popoverReferenceElement = target;

                const delay = this.showMentionPopover ? 0 : 300;
                this.popoverTimeout = setTimeout(() => {
                    this.showMentionPopover = true;
                }, delay);
            }
        },
        _mentionPopoverOnMouseLeave (event) {
            const target = event.target.closest('.mention');
            if (target) {
                if (this.popoverTimeout) {
                    clearTimeout(this.popoverTimeout);
                }

                this.popoverTimeout = setTimeout(() => {
                    this.hideMentionPopover();
                }, 100);
            }
        },
        onPopoverMouseEnter () {
            if (this.popoverTimeout) {
                clearTimeout(this.popoverTimeout);
            }
        },
        onPopoverMouseLeave () {
            this.hideMentionPopover();
        },
        _mentionPopoverCleanup () {
            if (this.popoverTimeout) {
                clearTimeout(this.popoverTimeout);
                this.popoverTimeout = null;
            }
            this.popoverReferenceElement = null;
        },
        hideMentionPopover () {
            this.showMentionPopover = false;
            this._mentionPopoverCleanup();
        },
    },
    computed: {
        mentionPopoverDisabled () {
            // Component may override (e.g. return this.isInline in document-artifact)
            return false;
        },
    },
};
